import * as React from 'react';
type Props = {
  className?: string;
};
export function Pescatarian({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Pescatarian"
      className={className}
    >
      <path
        d="M10.8603 23.4448C12.5209 20.2644 10.7145 16.9454 10.7145 16.9454M16.7394 21.8575L20.7034 24.4996V15.3421L16.7394 17.985M6.82819 19.639C6.62506 19.6441 6.46329 19.8124 6.46836 20.0163C6.47272 20.2201 6.64175 20.3812 6.8456 20.3768C7.04873 20.3725 7.20978 20.2034 7.20543 19.9996C7.20035 19.7957 7.03205 19.6347 6.82819 19.639ZM1.42859 20.424C1.42859 20.424 13.834 3.95022 32.0525 17.4728L38.3052 13.9877L38.5714 25.8272L32.1511 22.2877C32.1511 22.2877 15.8507 36.5938 1.42859 20.424Z"
        stroke="currentColor"
      />
    </svg>
  );
}
